import { getCurrentEnv } from "../../../environments";

const readRequired = (name: string, value: string): string => {
  const trimmed = value.trim();
  if (!trimmed) {
    throw new Error(`${name} is required for cloud APIs provider.`);
  }
  return trimmed;
};

const parseRegionFromUserPoolId = (userPoolId: string): string => {
  const idx = userPoolId.indexOf("_");
  if (idx <= 0) {
    throw new Error(`Invalid Cognito User Pool ID: ${userPoolId}`);
  }
  return userPoolId.slice(0, idx);
};

const parseRegionFromIdentityPoolId = (identityPoolId: string): string => {
  const idx = identityPoolId.indexOf(":");
  if (idx <= 0) {
    throw new Error(`Invalid Cognito Identity Pool ID: ${identityPoolId}`);
  }
  return identityPoolId.slice(0, idx);
};

export const getCloudConfig = () => {
  const env = getCurrentEnv();
  const userPoolId = readRequired("userPoolId", env.userPoolId);
  const identityPoolId = readRequired("identityPoolId", env.identityPoolId);

  const userPoolRegion = parseRegionFromUserPoolId(userPoolId);
  const identityPoolRegion = parseRegionFromIdentityPoolId(identityPoolId);
  const apiGatewayBaseUrl = readRequired("apiGatewayBaseUrl", env.apiGatewayBaseUrl);
  const s3BucketName = readRequired("s3BucketName", env.s3BucketName);
  const userPoolClientId = readRequired("userPoolClientId", env.userPoolClientId);

  return {
    apiGatewayBaseUrl,
    executeApiRegion: identityPoolRegion,
    identityPoolId,
    identityPoolRegion,
    s3BucketName,
    userPoolClientId,
    userPoolId,
    userPoolRegion,
  };
};
